import React, {useState, useEffect} from 'react';
import styles from './BackgroundMedia.module.css';

const BackgroundMedia = ({ geoposition, customStyle }) => {
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    const [videoSrc, setVideoSrc] = useState('');
    const [bgSrc, setBgSrc] = useState('');

    // Move media imports outside of component to prevent re-creation on each render
    const mediaAssets = {
        video: {
            california: require("../../../assets/video/california-optimized.mp4"),
            la: require("../../../assets/video/la-optimized.mp4"),
            sanFran: require("../../../assets/video/san-francisco-optimized.mp4"),
            sanDiego: require("../../../assets/video/san-diego-optimized.mp4"),
            alaska: require("../../../assets/video/alaska-optimized.mp4"),
            arizona: require("../../../assets/video/smoke-phoenix-optimized.mp4"),
            colorado: require("../../../assets/video/denver-optimized.mp4"),
            //minnesota: require("../../../assets/video/minnesota-optimized.mp4"),
            maine: require("../../../assets/video/maine-optimized.mp4"),
            miami: require("../../../assets/video/miami-optimized.mp4"),
            seattle: require("../../../assets/video/seattle-optimized.mp4"),
            boston: require("../../../assets/video/boston-optimized.mp4"),
            portland: require("../../../assets/video/portland-optimized.mp4"),
            lasVegas: require("../../../assets/video/las-vegas-optimized.mp4"),
            newYork: require("../../../assets/video/newyork-optimized.mp4"),
            newJersey: require("../../../assets/video/newjersey-optimized.mp4"),
            bc: require("../../../assets/video/bc-optimized.mp4"),
            vancouver: require("../../../assets/video/vancouver-optimized.mp4"),

        },
        background: {
            alabama: require("../../../assets/login/alabama.jpg"),
            arkansas: require("../../../assets/login/arkansas.jpg"),
            california: require("../../../assets/login/california.jpg"),
            la: require("../../../assets/login/la.jpg"),
            sanFran: require("../../../assets/login/san-francisco.jpg"),
            sanDiego: require("../../../assets/login/san-diego.jpg"),
            alaska: require("../../../assets/login/alaska.jpg"),
            arizona: require("../../../assets/login/phoenix.jpg"),
            colorado: require("../../../assets/login/denver.jpg"),
            connecticut: require("../../../assets/login/connecticut.jpg"),
            delaware: require("../../../assets/login/delaware.jpg"),
            georgia: require("../../../assets/login/georgia.jpg"),
            illinois: require("../../../assets/login/illinois.jpg"),
            louisville: require("../../../assets/login/louisville.jpg"),
            kentucky: require("../../../assets/login/kentucky.jpg"),
            louisiana: require("../../../assets/login/louisiana.jpg"),
            maine: require("../../../assets/login/maine.jpg"),
            maryland: require("../../../assets/login/maryland.jpg"),
            massachusetts: require("../../../assets/login/boston.jpg"),
            miami: require("../../../assets/login/miami.jpg"),
            michigan: require("../../../assets/login/michigan.webp"),
            minnesota: require("../../../assets/login/minneapolis.jpg"),
            mississippi: require("../../../assets/login/mississippi.jpg"),
            missouri: require("../../../assets/login/stlouis.jpg"),
            montana: require("../../../assets/login/yellowstone.jpg"),
            newhampshire: require("../../../assets/login/newhampshire.jpg"),
            newmexico: require("../../../assets/login/newmexico.jpg"),
            oklahoma: require("../../../assets/login/oklahoma.jpg"),
            pennsylvania: require("../../../assets/login/pennsylvania.jpg"),
            philadelphia: require("../../../assets/login/philadelphia.jpg"),
            pittsburgh: require("../../../assets/login/pittsburgh.jpg"),
            seattle: require("../../../assets/login/seattle.jpg"),
            northDakota: require("../../../assets/login/northdakota.jpg"),
            southDakota: require("../../../assets/login/southdakota.jpg"),
            boston: require("../../../assets/login/boston.jpg"),
            cleveland: require("../../../assets/login/cleveland.jpg"),
            ohio: require("../../../assets/login/ohio.jpg"),
            portland: require("../../../assets/login/portland.jpg"),
            lasVegas: require("../../../assets/login/las-vegas.jpg"),
            newJersey: require("../../../assets/login/newjersey.jpg"),
            newYork: require("../../../assets/login/newyork.jpg"),
            providence: require("../../../assets/login/providence.jpg"),
            rhodeIsland: require("../../../assets/login/rhodeisland.jpg"),
            vermont: require("../../../assets/login/vermont.jpg"),
            virginia: require("../../../assets/login/virginia.jpg"),
            washingtonDC: require("../../../assets/login/washingtondc.jpg"),
            westVirginia: require("../../../assets/login/westvirginia.jpg"),
            wisconsin: require("../../../assets/login/wisconsin.jpg"),
            wyoming: require("../../../assets/login/wyoming.jpg"),
            bc: require("../../../assets/login/bc.jpg"),
            vancouver: require("../../../assets/login/vancouver.jpg"),
        }
    };

    useEffect(() => {
        // Reset video loaded state when sources change
        setIsVideoLoaded(false);

        if (!geoposition?.state) {
            // Set default media
            setBgSrc(mediaAssets.background.la);
            setVideoSrc(mediaAssets.video.la);
            return;
        }

        // Create a function to update media sources
        const updateMediaSources = () => {
            switch (geoposition.state) {
                case 'Alabama':
                    setBgSrc(mediaAssets.background.alabama);
                    setVideoSrc(null);
                    break;
                case 'Arkansas':
                    setBgSrc(mediaAssets.background.arkansas);
                    setVideoSrc(null);
                    break;
                case 'Alaska':
                    setBgSrc(mediaAssets.background.alaska);
                    setVideoSrc(mediaAssets.video.alaska);
                    break;
                case 'Arizona':
                    setBgSrc(mediaAssets.background.arizona);
                    setVideoSrc(mediaAssets.video.arizona);
                    break;
                case 'Colorado':
                    setBgSrc(mediaAssets.background.colorado);
                    setVideoSrc(mediaAssets.video.colorado);
                    break;
                case 'Connecticut':
                    setBgSrc(mediaAssets.background.connecticut);
                    setVideoSrc(null);
                    break;
                case 'Delaware':
                    setBgSrc(mediaAssets.background.delaware);
                    setVideoSrc(null);
                    break;
                case 'Georgia':
                    setBgSrc(mediaAssets.background.georgia);
                    setVideoSrc(null);
                    break;
                case 'Illinois':
                    setBgSrc(mediaAssets.background.illinois);
                    setVideoSrc(null);
                    break;
                case 'Kentucky':
                    switch (geoposition.city) {
                        case 'Louisville':
                            setBgSrc(mediaAssets.background.louisville);
                            setVideoSrc(null);
                            break;
                        default:
                            setBgSrc(mediaAssets.background.kentucky);
                            setVideoSrc(null);
                            break;
                    }
                    break;
                case 'Louisiana':
                    switch (geoposition.city) {
                        case 'New Orleans':
                            setBgSrc(mediaAssets.background.louisiana);
                            setVideoSrc(null);
                            break;
                        default:
                            setBgSrc(mediaAssets.background.louisiana);
                            setVideoSrc(null);
                            break;
                    }
                    break;
                case 'Maine':
                    setBgSrc(mediaAssets.background.maine);
                    setVideoSrc(mediaAssets.video.maine);
                    break;
                case 'Mississippi':
                    setBgSrc(mediaAssets.background.mississippi);
                    setVideoSrc(null);
                    break;
                case 'Massachusetts':
                    setBgSrc(mediaAssets.background.massachusetts);
                    setVideoSrc(null);
                    break;
                case 'Maryland':
                    setBgSrc(mediaAssets.background.maryland);
                    setVideoSrc(null);
                    break;
                case 'New Hampshire':
                    setBgSrc(mediaAssets.background.newhampshire);
                    setVideoSrc(null);
                    break;
                case 'Oklahoma':
                    setBgSrc(mediaAssets.background.oklahoma);
                    setVideoSrc(null);
                    break;
                case 'Pennsylvania':
                    switch (geoposition.city) {
                        case 'Philadelphia':
                            setBgSrc(mediaAssets.background.philadelphia);
                            setVideoSrc(null);
                            break;
                        case 'Pittsburgh':
                            setBgSrc(mediaAssets.background.pittsburgh);
                            setVideoSrc(null);
                            break;
                        default:
                            setBgSrc(mediaAssets.background.pennsylvania);
                            setVideoSrc(null);
                            break;
                    }
                    break;
                case 'Florida':
                case 'Miami':
                    setBgSrc(mediaAssets.background.miami);
                    setVideoSrc(mediaAssets.video.miami);
                    break;
                case 'Minnesota':
                case 'Minneapolis':
                    setBgSrc(mediaAssets.background.minnesota);
                    setVideoSrc(null);
                    break;
                case 'Missouri':
                case 'St. Louis':
                    setBgSrc(mediaAssets.background.missouri);
                    setVideoSrc(null);
                    break;
                case 'Michigan':
                    setBgSrc(mediaAssets.background.michigan);
                    setVideoSrc(null);
                    break;
                case 'Montana':
                    setBgSrc(mediaAssets.background.montana);
                    setVideoSrc(null);
                    break;
                case 'Nevada':
                    setBgSrc(mediaAssets.background.lasVegas);
                    setVideoSrc(mediaAssets.video.lasVegas);
                    break;
                case 'New Mexico':
                    setBgSrc(mediaAssets.background.newmexico);
                    setVideoSrc(null);
                    break;
                case 'New Jersey':
                    setBgSrc(mediaAssets.background.newJersey);
                    setVideoSrc(mediaAssets.video.newJersey);
                    break;
                case 'New York':
                    setBgSrc(mediaAssets.background.newYork);
                    setVideoSrc(mediaAssets.video.newYork);
                    break;
                case 'Ohio':
                    switch (geoposition.city) {
                        case 'Cleveland':
                            setBgSrc(mediaAssets.background.cleveland);
                            setVideoSrc(null);
                            break;
                        case 'Cincinnati':
                            setBgSrc(mediaAssets.background.ohio);
                            setVideoSrc(null);
                            break;
                        default:
                            setBgSrc(mediaAssets.background.ohio);
                            setVideoSrc(null);
                    }
                    break;
                case 'District of Columbia':
                    setBgSrc(mediaAssets.background.washingtonDC);
                    setVideoSrc(null);
                    break;
                case 'Wisconsin':
                    setBgSrc(mediaAssets.background.wisconsin);
                    setVideoSrc(null);
                    break;
                    case 'Wyoming':
                    setBgSrc(mediaAssets.background.wyoming);
                    setVideoSrc(null);
                    break;
                case 'Washington':
                    setBgSrc(mediaAssets.background.seattle);
                    setVideoSrc(mediaAssets.video.seattle);
                    break;
                case 'Rhode Island':
                    switch (geoposition.city) {
                        case 'Providence':
                            setBgSrc(mediaAssets.background.providence);
                            setVideoSrc(null);
                            break;
                        default:
                            setBgSrc(mediaAssets.background.rhodeIsland);
                            setVideoSrc(null);
                    }
                    break;
                case 'Oregon':
                    setBgSrc(mediaAssets.background.portland);
                    setVideoSrc(mediaAssets.video.portland);
                    break;
                case 'North Dakota':
                    setBgSrc(mediaAssets.background.northDakota);
                    setVideoSrc(null);
                    break;
                case 'South Dakota':
                    setBgSrc(mediaAssets.background.southDakota);
                    setVideoSrc(null);
                    break;
                case 'Vermont':
                    setBgSrc(mediaAssets.background.vermont);
                    setVideoSrc(null);
                    break;
                case 'Virginia':
                    setBgSrc(mediaAssets.background.virginia);
                    setVideoSrc(null);
                    break;
                case 'West Virginia':
                    setBgSrc(mediaAssets.background.westVirginia);
                    setVideoSrc(null);
                    break;
                case 'California':
                    switch (geoposition.city) {
                        case 'San Francisco':
                            setBgSrc(mediaAssets.background.sanFran);
                            setVideoSrc(mediaAssets.video.sanFran);
                            break;
                        case 'Los Angeles':
                            setBgSrc(mediaAssets.background.la);
                            setVideoSrc(mediaAssets.video.la);
                            break;
                        case 'San Diego':
                            setBgSrc(mediaAssets.background.sanDiego);
                            setVideoSrc(mediaAssets.video.sanDiego);
                            break;
                        default:
                            setBgSrc(mediaAssets.background.california);
                            setVideoSrc(mediaAssets.video.california);
                    }
                    break;
                case 'British Columbia':
                    switch (geoposition.city) {
                        case 'Vancouver':
                            setBgSrc(mediaAssets.background.vancouver);
                            setVideoSrc(mediaAssets.video.vancouver);
                            break;
                        default:
                            setBgSrc(mediaAssets.background.bc);
                            setVideoSrc(mediaAssets.video.bc);
                    }
                    break;
                default:
                    setBgSrc(null);
                    setVideoSrc(null);
            }
        };

        updateMediaSources();
    }, [geoposition?.state, geoposition?.city]); // Only depend on the specific properties we use

    // Force video element recreation when source changes
    const videoKey = `video-${videoSrc}`;

    return (
        <>
            <div
                className={styles.backgroundImage}
                style={{ backgroundImage: `url(${bgSrc})` }}
            />
            <div className={styles.absBackground} style={customStyle}/>
            <div className={styles.videoContainer}>
                {videoSrc && (
                    <video
                        key={videoKey}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className={`${styles.backgroundVideo} ${isVideoLoaded ? styles.videoLoaded : ''}`}
                        onLoadedData={() => setIsVideoLoaded(true)}
                    >
                        <source src={videoSrc} type="video/mp4"/>
                    </video>
                )}
            </div>
        </>
    );
};

export default BackgroundMedia;
